import thunkMiddleware from 'redux-thunk';
import {AnyAction, combineReducers, configureStore, ThunkAction} from '@reduxjs/toolkit';
import {appReducer} from "./app-reduser";
import {dateReducer} from "./expense-date-reduser";
import {topTabsReducer} from "./top-tabs-reduser";
import {roleReducers} from "./user-reduser";
import {popupsReducer} from "./popups-reducer";
import {loginReducer} from "features/model/slice/lodinSlice";
import {userReducer} from "entities/User/model/slice/userSlice";
import {profileReducer} from "entities/Profile/model/slice/profileSlice";
import {cabinetReducer} from "entities/Cabiner/model/slice/cabinetSlice";
import {registerReducer} from "features/model/slice/registerSlice";
import {confirmReducer} from "entities/Confirm/modal/slice/confirmSlice";
import {resetPasswordEmailReducer} from "features/model/slice/resetPasswordEmailSlice";
import {resetPasswordReducer} from "features/model/slice/resetPasswordSlise";
import {logoutReducer} from "features/model/slice/logoutSlice";
import {accountUserActions, accountUserReducer} from "./accountLoginSlice";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import {paymentsReducer} from "features/model/slice/payments/paymentsSlice";
import {groupsReducer} from "features/model/slice/groups/groupsSlice";
import {changePasswordReducer} from "features/model/slice/changePasswordSlice";
import {editProfileReducer} from "features/model/slice/editProfileSlice";
import {avatarReducer} from "features/model/slice/avatarSlice";
import {studentsReducer} from "features/model/slice/groups/set-students/setStudentsSlice";
import {groupsLessonsReducer,} from "features/model/slice/groups/set-groups-lessons/setGroupsLessonsSlice";
import {lessonsReducer} from "features/model/slice/groups/set-lessons/setLessons";
import {lessonsStudentsReducer} from "features/model/slice/groups/set-lessons-students/setLessonsStudents";
import {homeWorkReducer} from "features/model/slice/groups/set-lessons-students/set-home-work-slice/setHomeWorkSlice";
import {problemsReducer} from "features/model/slice/groups/set-lessons/set-problems/setProblems";
import {noteReducer} from "features/model/slice/groups/set-lessons/set-note/setNote";
import {settingsReducer} from "features/model/slice/groups/set-groups-lessons/set-setting-group/setSettingGroup";
import {studentInfoReducer} from "features/model/slice/student-info/StudentInfoSlice";
import {studentLessonsReducer} from "features/model/slice/student-info/StudentInfoLessonsSlice";
import {homeworkLessonsReducer} from "features/model/slice/student-info/StudentInfoHomeworksSlice";
import {cutsReducer} from "features/model/slice/student-info/StudentInfoCutSlice";
import {testsReducer} from "features/model/slice/test/testSlice";
import {testsByIdReducer} from "features/model/slice/test/test-by-id/testByIdSlice";
import {testsTeacherReducer} from "features/model/slice/test/test-teacher/testTeacherSlice";
import {testsStudentsByIdReducer} from "features/model/slice/test/test-students-by-id/testStudentById";
import {addLessonReducer} from "features/model/slice/addLessonSlice";
import {homeworkResponseStudentReducer} from "features/model/slice/homework/homeworkResponseStudent";
import {homeWorkTeacherReducer} from "features/model/slice/homework/HomeworkAnswer";
import {coursesReducer} from "features/model/slice/courses/coursesSlice";
import {courseByIdReducer} from "features/model/slice/courses/curses-by/cursesBy";
import {joinMeetingReducer} from "features/model/slice/groups/botton-lesson/joinMeetingSlice";
import {coursesResponseUrlReducer} from "features/model/slice/courses/courses-response-url/coursesResponseUrl";
import {bankTransferReducer} from "features/model/slice/courses/get-bank-transfer/getBankTransferSlice";
import {reviewLessonReducer} from "features/model/slice/lessons/reviewLessonSlice";
import {lessonsDemoReducer} from "features/model/slice/lessons/lessons-demo/setLessonsDemo";
import {actsReducer} from "features/model/slice/payments/actsSlice";
import {socialsReducer} from "features/model/slice/leave-review/leaveReviewSlice";
import {postSocialsReducer} from "features/model/slice/leave-review/postLeaveReviewSlice";
import {changePasswordErrorReducer} from "features/model/slice/сhange-assword/changePassword";
import {groupsListingReducer} from "features/model/slice/create-test/group-listing/groupListingSlice";
import {studentListingReducer} from "features/model/slice/create-test/students-listing/studentListingSlice";
import {createTestFormReducer} from "features/model/slice/create-test/create-test-form/createTestForm";
import {responseAddTestReducer} from "features/model/slice/create-test/add-test/responseAddTest";
import {getTestsReducer} from "features/model/slice/test/get-test/getTestSlice";
import {deleteTestsReducer} from "features/model/slice/test/success-test/delete-test/deleteTest";
import {lessonsTestReducer} from "features/model/slice/lessons/lessons-test/lessonsTest";
import {lessonsTestAllowedReducer} from "features/model/slice/lessons/lessons-test-allowed/lessonsTestAllowedSlice";
import {responseAddFileReducer} from "features/model/slice/lessons/response-add-file/responseAddFile";
import {summaryTableReducer} from "features/model/slice/hr/summary-table/summaryTableSlice";
import {statisticsReducer} from "features/model/slice/hr/statistics/statisticsSlice";
import {testsTakeReducer} from "features/model/slice/test/test-student/test-take/testTakeSlice";
import {testViewAnswerIdReducer} from "features/model/slice/test/test-view-answer-id/testViewAnswerIdSlice";

import {preservedTestsReducer} from "features/model/slice/test/success-test/preserved-test/preservedTestSlice";
import {deleteFileSliceReducer} from "features/model/slice/test/delete-file/deleteFileSlice";
import {correctTestReducer} from "features/model/slice/test/correct-test/correctTestSlice";
import {scheduleReducer} from "features/model/slice/groups/schedule/scheduleSlice";
import {filtersReducer} from "features/model/slice/groups/filters-slice/filtersSlice";
import {errorReducer} from "features/model/slice/error/errorSlice";
import {calendarReducer} from "features/model/slice/calendar/calendarSlice";
import {scheduleUserReducer} from "features/model/slice/groups/schedule/schedule-user/scheduleUserSlice";
import {scheduleDevReducer} from "features/model/slice/groups/schedule/schedule-dev-slice/scheduleDevSlice";


const rootReducer = combineReducers({
    loginForm: loginReducer,
    registerForm: registerReducer,
    resetPasswordEmail: resetPasswordEmailReducer,
    resetPassword: resetPasswordReducer,
    payments: paymentsReducer,
    acts: actsReducer,
    socials: socialsReducer,
    postSocials: postSocialsReducer,
    groups: groupsReducer,
    schedule: scheduleReducer,
    scheduleDev: scheduleDevReducer,
    scheduleUser: scheduleUserReducer,
    responseStudentHomework: homeworkResponseStudentReducer,
    test: testsReducer,
    testsTake: testsTakeReducer,
    correctTest: correctTestReducer,
    testViewAnswerId: testViewAnswerIdReducer,
    deleteTests: deleteTestsReducer,
    preservedTests: preservedTestsReducer,
    responseAddTest: responseAddTestReducer,
    testTeacher: testsTeacherReducer,
    groupsListing: groupsListingReducer,
    studentListing: studentListingReducer,
    createTestForm: createTestFormReducer,
    testById: testsByIdReducer,
    testStudentsById: testsStudentsByIdReducer,
    getTests: getTestsReducer,
    changePassword: changePasswordReducer,
    addLesson: addLessonReducer,
    editProfile: editProfileReducer,
    profile: profileReducer,
    students: studentsReducer,
    studentInfo: studentInfoReducer,
    studentLessons: studentLessonsReducer,
    cuts: cutsReducer,
    homeworkLessons: homeworkLessonsReducer,
    groupsLessons: groupsLessonsReducer,
    lessons: lessonsReducer,
    lessonsDemo: lessonsDemoReducer,
    lessonsTest: lessonsTestReducer,
    testAllowed: lessonsTestAllowedReducer,
    responseAddFile: responseAddFileReducer,
    lessonsStudents: lessonsStudentsReducer,
    deleteFile: deleteFileSliceReducer,
    note: noteReducer,
    problems: problemsReducer,
    settings: settingsReducer,
    homeWork: homeWorkReducer,
    homeWorkTeacher: homeWorkTeacherReducer,
    changePasswordError: changePasswordErrorReducer,
    user: userReducer,
    accountUser: accountUserReducer,
    logout: logoutReducer,
    confirm: confirmReducer,
    cabinet: cabinetReducer,
    app: appReducer,
    role: roleReducers,
    date: dateReducer,
    topTabs: topTabsReducer,
    popups: popupsReducer,
    avatar: avatarReducer,
    courses: coursesReducer,
    coursesById: courseByIdReducer,
    joinMeeting: joinMeetingReducer,
    coursesResponseUrl: coursesResponseUrlReducer,
    bankTransfer: bankTransferReducer,
    reviewLesson: reviewLessonReducer,
    summaryTable: summaryTableReducer,
    statistics: statisticsReducer,
    filers: filtersReducer,
    error: errorReducer,
    calendar: calendarReducer,
})


export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).prepend(thunkMiddleware),
});

const savedUserData = localStorage.getItem(USER_LOCALSTORAGE_KEY);

if (savedUserData) {
    const userData = JSON.parse(savedUserData);
    store.dispatch(accountUserActions.accountUser(userData.success));
}

export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = typeof store.dispatch

export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    AnyAction
>
// @ts-ignore
window.store = store;


